export default __webpack_public_path__ + "static/media/benefit_12.c27d9e8d.png";